import { useEffect } from "@wordpress/element";
import Paper from "@mui/material/Paper";
import FormHelperText from "@mui/material/FormHelperText";
import Typography from "@mui/material/Typography";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "vino/core";
import { useCheckoutContext } from "vino/context";
import { getDeliveryMethods } from "store/vino/deliveryMethodsSlice";
import {
	checkCompliance,
	resetShippingCompliance,
} from "store/vino/shippingComplianceSlice";
import { updateShippingRate } from "store/vino/checkoutSlice";
import { ShippingMethodSchema } from "vino/components/cart-checkout/models";
import DeliveryMethodList from "./DeliveryMethodList";
import ErrorList from "./ErrorList";

const ShippingOptions = ({ onBack }) => {
	const { cartLineItems } = useCheckoutContext();
	const dispatch = useDispatch();
	const checkout = useSelector(({ vino }) => vino.checkout);
	const compliance = useSelector(({ vino }) => vino.shippingCompliance);
	const { isSubmitting } = checkout;

	const methods = useForm({
		mode: "onChange",
		defaultValues: {
			shippingMethod: "",
		},
		resolver: yupResolver(ShippingMethodSchema),
	});

	const {
		formState: { errors },
		handleSubmit,
	} = methods;

	useEffect(() => {
		if (checkout.checkoutId) {
			dispatch(checkCompliance(checkout.checkoutId));
		}
		return () => {
			dispatch(resetShippingCompliance());
		};
	}, [dispatch, cartLineItems]);

	useEffect(() => {
		if (compliance.isCompliant) {
			dispatch(getDeliveryMethods(checkout.checkoutId));
		}
	}, [compliance.isCompliant]);

	const onSubmit = () => {
		dispatch(updateShippingRate(checkout));
	};

	return (
		<Paper className="w-full flex flex-col rounded-20 shadow">
			<FormProvider {...methods}>
				<form
					noValidate
					className="w-full flex flex-col px-16"
					onSubmit={handleSubmit(onSubmit)}
					autoComplete="off"
				>
					<div className="flex items-center justify-between py-10 px-20">
						<Typography className="text-16 font-bold">
							Shipping Details
						</Typography>
					</div>

					<DeliveryMethodList />
					<div className="w-full px-20">
						<div className="mb-16 flex flex-col">
							{errors.shippingMethod && (
								<FormHelperText error>
									{errors.shippingMethod.message}
								</FormHelperText>
							)}

							<ErrorList compliance={compliance} />
						</div>

						<div className="flex justify-between w-full mb-20">
							<Button onClick={onBack}>Back</Button>
							<Button
								type="submit"
								isSubmitting={isSubmitting}
								disabled={compliance.isCompliant !== true}
							>
								Next: Payment
							</Button>
						</div>
					</div>
				</form>
			</FormProvider>
		</Paper>
	);
};

export default ShippingOptions;
